module.exports = __webpack_public_path__ + "img/gh-36330m-3-34.prt.51b07b06.jpg";